
import { format, Locale } from 'date-fns';
import { enGB, it } from 'date-fns/locale';
import { DateShortcutType } from '../../models/type';

const locales = { enGB, it };

export const isToday = (d: Date) => {
  const today = new Date();
  return (
    d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear()
  );
};

export const getDateAsISOString = (date: any) => {
  if (date && date instanceof Date) {
    return date.toISOString();
  }
};

export const getDateFnsLocaleFromLang = (lang = 'it'): Locale => {
  let langFixed = lang;
  let temp = lang.split('-');

  if (temp.length > 1) {
    langFixed = temp[0];
  }
  if (langFixed === 'en') {
    langFixed = 'enGB';
  }
  return locales[langFixed as keyof typeof locales];
};

export const getTranslatedStringFromDate = (date: any, lang: string) => {
  if (date && date instanceof Date) {
    return format(date, 'd LLL', { locale: getDateFnsLocaleFromLang(lang) });
  }
};

export const getDateMinutesAgo = (minutes: number, startDate?: any) => {
  let dateRef = new Date();
  if (startDate && startDate instanceof Date) {
    dateRef = startDate;
  }
  dateRef.setMinutes(dateRef.getMinutes() - minutes);
  return dateRef;
};

export const getDateHoursAgo = (hours: number, startDate?: any) => {
  let dateRef = new Date();
  if (startDate && startDate instanceof Date) {
    dateRef = startDate;
  }
  dateRef.setHours(dateRef.getHours() - hours);
  return dateRef;
};

export const getDateDaysAgo = (days: number, startDate?: any) => {
  let dateRef = new Date();
  if (startDate && startDate instanceof Date) {
    dateRef = startDate;
  }
  dateRef.setDate(dateRef.getDate() - days);
  return dateRef;
};

export const getDateByShortcut = (shortcut: DateShortcutType) => {
  switch (shortcut) {
    case '1m':
      return getDateMinutesAgo(1);
    case '5m':
      return getDateMinutesAgo(5);
    case '10m':
      return getDateMinutesAgo(10);
    case '15m':
      return getDateMinutesAgo(15);
    case '1h':
      return getDateHoursAgo(1);
    case '3h':
      return getDateHoursAgo(3);
    case '6h':
      return getDateHoursAgo(6);
    case '12h':
      return getDateHoursAgo(12);
    case '1d':
      return getDateDaysAgo(1);
    case '3d':
      return getDateDaysAgo(3);
    case '1w':
      return getDateDaysAgo(7);
      case '2w':
      return getDateDaysAgo(14);
    case '1month':
      return getDateDaysAgo(31);
    default:
      return new Date();
  }
};
